import { Link } from "@tanstack/react-router";
import { Instagram, Youtube } from "lucide-react";
import logoFeo from "@/assets/feo/logo-feo.png";
import { useSiteLink } from "@/lib/managed-links/use-site-link";

export function SiteFooter() {
  const instagram = useSiteLink("link.social.instagram", "https://www.instagram.com/fisioemortopedia");
  const youtube = useSiteLink("link.social.youtube", "https://www.youtube.com/fisioemortopedia");
  const spotify = useSiteLink("link.social.spotify", "https://open.spotify.com/show/1wQnzJyVAmpHrSh951rInK");
  const certificacao = useSiteLink("link.header.certificacao", "/certificacao");
  const star = useSiteLink("link.header.star", "/star");
  return (
    <footer className="bg-[#13123a] text-white">
      <div className="container mx-auto px-6 py-14">
        <div className="grid gap-10 md:grid-cols-3 items-start">
          <div>
            <img loading="lazy" decoding="async" src={logoFeo} alt="Fisio em Ortopedia" className="h-12 w-auto mb-4" />
            <p className="text-white/70 text-sm leading-relaxed max-w-xs">
              Mais do que educação. Um Portal de Oportunidades.
            </p>
          </div>

          <div>
            <h2 className="font-bold mb-4 text-[var(--primary)] uppercase tracking-wider text-xs">Navegação</h2>
            <ul className="space-y-2 text-sm text-white/80">
              <li><Link to="/quem-somos" className="hover:text-[var(--primary)]">Quem Somos</Link></li>
              <li><Link to="/professores" className="hover:text-[var(--primary)]">Corpo Docente</Link></li>
              <li><Link to="/depoimentos" className="hover:text-[var(--primary)]">Depoimentos</Link></li>
              <li><Link to="/e-fisio" className="hover:text-[var(--primary)]">Blog E-FISIO</Link></li>
              <li><Link to="/pos" className="hover:text-[var(--primary)]">Pós-graduações</Link></li>
              <li><a href={certificacao} className="hover:text-[var(--primary)]">Certificações</a></li>
              <li><a href={star} className="hover:text-[var(--primary)]">Star Cursos</a></li>
              <li><Link to="/politica-de-privacidade" className="hover:text-[var(--primary)]">Política de Privacidade</Link></li>

            </ul>
          </div>

          <div>
            <h2 className="font-bold mb-4 text-[var(--primary)] uppercase tracking-wider text-xs">Siga-nos</h2>
            <div className="flex gap-4">
              <a href={instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full bg-white/10 hover:bg-[var(--primary)] hover:text-[#13123a] flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="h-10 w-10 rounded-full bg-white/10 hover:bg-[var(--primary)] hover:text-[#13123a] flex items-center justify-center transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
              <a href={spotify} target="_blank" rel="noopener noreferrer" aria-label="Spotify" className="h-10 w-10 rounded-full bg-white/10 hover:bg-[var(--primary)] hover:text-[#13123a] flex items-center justify-center transition-colors">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M12 0a12 12 0 100 24 12 12 0 000-24zm5.5 17.3a.75.75 0 01-1 .25c-2.8-1.7-6.3-2.1-10.5-1.2a.75.75 0 11-.3-1.5c4.5-1 8.4-.6 11.5 1.3.3.2.4.7.3 1.15zm1.5-3.3a.94.94 0 01-1.3.3c-3.2-2-8.1-2.5-11.9-1.4a.94.94 0 11-.5-1.8c4.4-1.3 9.7-.7 13.4 1.6.4.3.6.9.3 1.3zm.1-3.4c-3.8-2.3-10.1-2.5-13.8-1.4a1.13 1.13 0 11-.6-2.2c4.2-1.3 11.2-1 15.6 1.6a1.13 1.13 0 01-1.2 1.9z"/></svg>
              </a>
            </div>
            <p className="text-white/60 text-xs mt-6">
              contato@fisioemortopedia.com.br
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-center text-white/50 text-xs">
          Todos os direitos reservados.&nbsp;Fisio em Ortopedia&nbsp;© {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
}
